/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BreedDto } from '../../models/breed-dto';

export interface BreedControllerFindAllActive$Params {
}

export function breedControllerFindAllActive(http: HttpClient, rootUrl: string, params?: BreedControllerFindAllActive$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BreedDto>>> {
  const rb = new RequestBuilder(rootUrl, breedControllerFindAllActive.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BreedDto>>;
    })
  );
}

breedControllerFindAllActive.PATH = '/api/breed/active';
